export const EMPTY_ARRAY = Object.freeze([]); // Optionally frozen to make immutable
